<template>
  <div style="font-size: 48px; color: #fff">会议评分系统</div>
</template>

<script lang="ts" setup></script>
